import React, { useEffect, useRef, useState } from "react";
import "./TimePicker.scss";

const TimePicker = ({ interval = 5, onChange }) => {
  const inputRef = useRef(null);
  const pickerRef = useRef(null);
  const [showPicker, setShowPicker] = useState(false);
  const [positionAbove, setPositionAbove] = useState(false);
  const [selectedTime, setSelectedTime] = useState(getNextTime(interval));

  useEffect(() => {
    if (showPicker) {
      const inputRect = inputRef.current.getBoundingClientRect();
      const pickerHeight = 180; // estimated height
      const spaceBelow = window.innerHeight - inputRect.bottom;
      const shouldShowAbove = spaceBelow < pickerHeight;

      setPositionAbove(shouldShowAbove);
    }
  }, [showPicker]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(e.target) &&
        !inputRef.current.contains(e.target)
      ) {
        setShowPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function getNextTime(interval) {
    const now = new Date();
    let minutes = now.getMinutes();
    let remainder = interval - (minutes % interval);
    if (remainder === interval) remainder = 0;

    now.setMinutes(minutes + remainder);
    now.setSeconds(0);

    const hour = now.getHours();
    const minute = now.getMinutes();
    const ampm = hour >= 12 ? "PM" : "AM";

    return {
      hour: hour % 12 === 0 ? 12 : hour % 12,
      minute,
      ampm,
    };
  }

  const formatTime = ({ hour, minute, ampm }) =>
    `${hour.toString().padStart(2, "0")} : ${minute
      .toString()
      .padStart(2, "0")} ${ampm}`;

  const handleArrowClick = (field, direction) => {
    setSelectedTime((prev) => {
      let { hour, minute, ampm } = prev;

      if (field === "hour") {
        hour = direction === "up" ? hour + 1 : hour - 1;
        if (hour > 12) hour = 1;
        if (hour < 1) hour = 12;
      } else if (field === "minute") {
        minute = direction === "up" ? minute + interval : minute - interval;

        if (minute >= 60) {
          minute = 0;
          hour = hour === 12 ? 1 : hour + 1;
        } else if (minute < 0) {
          minute = 60 - interval;
          hour = hour === 1 ? 12 : hour - 1;
        }
      } else if (field === "ampm") {
        ampm = ampm === "AM" ? "PM" : "AM";
      }

      const updated = { hour, minute, ampm };
      onChange?.(formatTime(updated));
      return updated;
    });
  };

  return (
    <div className="time-picker-wrapper position-relative">
      <input
        type="text"
        className="form-control"
        ref={inputRef}
        readOnly
        value={formatTime(selectedTime)}
        onClick={() => setShowPicker(true)}
      />

      {showPicker && (
        <div
          className={`picker-container shadow-sm ${
            positionAbove ? "above" : ""
          }`}
          ref={pickerRef}
        >
          <div className="picker-row">
            {["hour", "minute", "ampm"].map((field, idx) => (
              <div key={field} className="picker-item text-center mx-2">
                <div onClick={() => handleArrowClick(field, "up")}>▲</div>
                <div className="picker-value">
                  {selectedTime[field].toString().padStart(2, "0")}
                </div>
                <div onClick={() => handleArrowClick(field, "down")}>▼</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TimePicker;
